import * as React from "react"

/**
 * Code block matching the gatsby-remark-prismjs styling used in blog posts,
 * with a copy-to-clipboard button. For use in JSX pages, where remark
 * plugins don't apply.
 */
const CodeBlock = ({ code, language = "bash" }) => {
  const [copied, setCopied] = React.useState(false)

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <div className="gatsby-highlight" style={{ position: "relative" }}>
      <button
        type="button"
        onClick={handleCopy}
        aria-label={copied ? "Copied" : "Copy code to clipboard"}
        style={{
          position: "absolute",
          top: "0.5rem",
          right: "0.5rem",
          padding: "0.25rem 0.6rem",
          fontSize: "0.75rem",
          fontFamily: "var(--fontFamily-sans, system-ui, sans-serif)",
          fontWeight: 600,
          color: copied ? "#22863a" : "var(--color-text-light, #4f5969)",
          background: "transparent",
          border: "1px solid var(--color-accent, #d1dce5)",
          borderRadius: "4px",
          cursor: "pointer",
        }}
      >
        {copied ? "Copied!" : "Copy"}
      </button>
      <pre className={`language-${language}`}>
        <code className={`language-${language}`}>{code}</code>
      </pre>
    </div>
  )
}

export default CodeBlock
